import _ from "lodash"
import { useHubAgenda } from "../../../store/hub/useHubAgenda"
import { formatName, getDay } from "../../functions"
import { useMerchant } from "../../../store/global/useMerchant"

export class HubController {
  heatMapSize = 7
  hubAction = useHubAgenda.getState().actions

  constructor(props) {
    this.agendaModel = props.models.agenda
    this.supportModel = props.models.support
    this.assinaturaModel = props.models.assinatura

    this.init()
  }

  init() {
    this.getDay()
    this.buildAssinaturaDetails()
  }

  buildAgendaDetails(currentDay) {
    this.agendaModel.details(currentDay.format('YYYY-MM-DD'))
  }

  buildSuportTickets(storeId) {
    this.supportModel.findTickets(storeId, {
      status: "aguardando usuario,em analise,em progresso"
    })
  }

  buildHeatMap(currentDay) {
    this.hubAction.setClearHours()

    const dates = _.range(this.heatMapSize).map(i => {
      const date = currentDay.add(i, 'day').format('YYYY-MM-DD')
      this.agendaModel.heatMap(date)
      if (!useHubAgenda.getState().data.heatMap[date]) {
        this.hubAction.setHeatMap(date, {
          date: getDay(date).format('YYYY-MM-DD'),
          weekDay: formatName(getDay(date).format('ddd DD/MM')),
          loading: true
        })
      }
      return date
    })

    this.hubAction.setHeatMapDates(dates)
  }

  buildAssinaturaDetails() {
    this.assinaturaModel.details()
  }


  getDay(day) {
    const currentDay = getDay(day)

    this.buildAgendaDetails(currentDay)
    this.buildHeatMap(currentDay)

    return currentDay.format('YYYY-MM-DD')
  }

  getTickets(storeId) {
    this.buildSuportTickets(storeId)
  }
}
